(() => {
  const root = document.documentElement;
  const validPreferences = ['light', 'dark', 'system'];
  const getSystemTheme = () => window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';

  function applyPreference(preference, persist = true) {
    const nextPreference = validPreferences.includes(preference) ? preference : 'system';
    root.dataset.ahvellaPreference = nextPreference;
    root.dataset.ahvellaTheme = nextPreference === 'system' ? getSystemTheme() : nextPreference;
    if (persist) {
      try { window.localStorage.setItem('ahvella-theme', nextPreference); } catch (error) { /* Storage is optional. */ }
    }
    document.querySelectorAll('[data-ahvella-theme-choice]').forEach((choice) => {
      const active = choice.dataset.ahvellaThemeChoice === nextPreference;
      choice.dataset.active = String(active);
      choice.setAttribute('aria-pressed', String(active));
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    applyPreference(root.dataset.ahvellaPreference || 'system', false);
    document.querySelectorAll('[data-ahvella-theme-choice]').forEach((choice) => {
      choice.addEventListener('click', () => {
        applyPreference(choice.dataset.ahvellaThemeChoice);
        choice.closest('details')?.removeAttribute('open');
      });
    });
    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const syncSystemTheme = () => { if (root.dataset.ahvellaPreference === 'system') applyPreference('system', false); };
    media.addEventListener?.('change', syncSystemTheme);
  });
})();
